import React from 'react';
import api from '../../services/api';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import Divider from 'material-ui/Divider';
import Subheader from 'material-ui/Subheader';

class Strategic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      statusData: [
          <TableRow key={null}>
            <TableRowColumn>Carregando...</TableRowColumn>            
          </TableRow>],
      industryData: [
          <TableRow key={null}>
            <TableRowColumn>Carregando...</TableRowColumn>            
      </TableRow>],
      countryData: [
          <TableRow key={null}>
            <TableRowColumn>Carregando...</TableRowColumn>            
          </TableRow>]
    };
  }
  componentDidMount() {
    var self = this;
    this.updateStatusData();
    this.updateIndustryData();
    this.updateCountryData();
  }
  componentDidUpdate(prevProps, nextState) {
  }
  updateStatusData() {
    var self = this;
    api.getStrategicStatus().then((rs) => {      
      var aux = [];
      var total = 0;
      rs.response.forEach(function(item){
        if(item._id)
          total = total + item.count;
      })
      var aux = rs.response.map(function(item){
        if(item._id)
        return <TableRow key={item._id}>
            <TableRowColumn style={{width:"50%"}}>{item._id}</TableRowColumn>
            <TableRowColumn>{item.count}</TableRowColumn>
            <TableRowColumn>{(100*item.count/total).toFixed(2)}</TableRowColumn>
          </TableRow>;
      });
      
      this.setState({ statusData: aux });
    }).catch((error) => {
        console.error(error);
      });
  }
  updateIndustryData() {
    var self = this;
    api.getStrategicIndustry().then((rs) => {          
      var aux = [];
      var total = 0;
      rs.response.forEach(function(item){
        if(item._id)
          total = total + item.count;
      })
      var aux = rs.response.map(function(item){
        if(item._id)
          return <TableRow key={item._id}>
              <TableRowColumn style={{width:"50%"}}>{item._id}</TableRowColumn>
              <TableRowColumn>{item.count}</TableRowColumn>
              <TableRowColumn>{(100*item.count/total).toFixed(2)}</TableRowColumn>
            </TableRow>;
      });      
      this.setState({ industryData: aux });
    }).catch((error) => {
        console.error(error);
      });
  }
  updateCountryData() {
    var self = this;
    api.getStrategicCountry().then((rs) => {
      var aux = [];
      var total = 0;
      rs.response.forEach(function(item){
        if(item._id)
          total = total + item.count;
      })
      var aux = rs.response.map(function(item){
        if(item._id)
        return <TableRow key={item._id}>
            <TableRowColumn style={{width:"50%"}}>{item._id}</TableRowColumn>
            <TableRowColumn>{item.count}</TableRowColumn>
            <TableRowColumn>{(100*item.count/total).toFixed(2)}</TableRowColumn>
          </TableRow>;
      });      
      this.setState({ countryData: aux });
    }).catch((error) => {
        console.error(error);
      });
  }
  render() {
    return (
      <div style={{ width: "100%" }} >
        <br /><h1>Informações Estratégicas</h1>        
        <Subheader>Situação Profissional dos Alumni</Subheader>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn style={{width:"50%"}}>Situação Profissional</TableHeaderColumn>
              <TableHeaderColumn>#</TableHeaderColumn>
              <TableHeaderColumn>%</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.state.statusData}            
          </TableBody>
        </Table>

        <Subheader style={{marginTop:"30px"}}>Paises onde residem os Alumni</Subheader>

        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn style={{width:"50%"}}>País</TableHeaderColumn>
              <TableHeaderColumn>#</TableHeaderColumn>
              <TableHeaderColumn>%</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.state.countryData}            
          </TableBody>
        </Table>

        <Subheader style={{marginTop:"30px"}}>Indústria dos Alumni</Subheader>

        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow>
              <TableHeaderColumn style={{width:"50%"}}>Indústria</TableHeaderColumn>
              <TableHeaderColumn>#</TableHeaderColumn>
              <TableHeaderColumn>%</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.state.industryData}            
          </TableBody>
        </Table>
      </div>

    )
  }
};
export default Strategic;


// WEBPACK FOOTER //
// ./src/pages/reports/Strategic.js